import {
    GET_DURATIONS, ADD_DURATION, DURATION_ERROR
} from '../actions/types';


const initialState = { durations: [], duration: null, loading: true, error: {} }

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_DURATIONS:
            return {
                ...state,
                durations: payload,
                loading: false
            }
        case ADD_DURATION:
            return {
                ...state,
                durations: [...state.durations, payload],
                loading: false
            }
        case DURATION_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            }
        default:
            return state;
    }

}